/* eslint-disable indent */

import { InboxMessage } from '@src/main/modules/messages/domain/message/inbox/inbox-message.interface';
import { OutboxMessage } from '@src/main/modules/messages/domain/message/outbox/outbox-message.interface';
import { InboxMessageEntity } from '@src/main/modules/messages/infrastructure/entity/inbox-message.entity';
import { OutboxMessageEntity } from '@src/main/modules/messages/infrastructure/entity/outbox-message.entity';
import { validDate } from '@src/main/shared/utils/dateUtils';

export function toInboxMessage(entity: InboxMessageEntity): InboxMessage {
  return {
    ...entity,
    sendDate: new Date(entity.sendDate),
    readDate: validDate(entity.readDate),
    deletedDate: new Date(entity.deletedDate),
    recipients: entity.recipients.map((r) => ({
      ...r,
      readDate: validDate(r.readDate),
      deletedDate: validDate(r.deletedDate),
    })),
  };
}

export function toOutboxMessage(entity: OutboxMessageEntity): OutboxMessage {
  return {
    ...entity,
    recipients: entity.recipients.map((r) => ({
      ...r,
      readDate: validDate(r.readDate),
      deletedDate: validDate(r.deletedDate),
    })),
    messageHtml: entity.messageHtml,
    sendDate: validDate(entity.sendDate),
    respondedFrom: entity.respondedFrom
      ? {
          ...entity.respondedFrom,
          sendDate: validDate(entity.respondedFrom.sendDate),
          readDate: validDate(entity.respondedFrom.readDate),
          deletedDate: validDate(entity.respondedFrom.deletedDate),
          recipients: entity.respondedFrom.recipients.map((r) => ({
            ...r,
            readDate: validDate(r.readDate),
            deletedDate: validDate(r.deletedDate),
          })),
        }
      : null,
    initDate: validDate(entity.initDate),
    endDate: validDate(entity.endDate),
  };
}
